/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable */
import React from 'react';
import { Button, Input, Modal, Spin, message, Progress } from 'antd';

import ReactResizeDetector from 'react-resize-detector';
import {useNavigate, useParams} from 'react-router-dom';

import {useStore, IQuizOption, IQuizResult} from '../../../../store';
import FinalQuiz from '../../components/FinalQuiz';
import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import DownwardIcon from '../../../../../../assets/education/quiz/downward_icon.png';
import ImgNotPass from '../../../../../../assets/education/quiz/no_pass_person.png';
import Upset from '../../../../../../assets/finance/quiz/upset.png';
import Smile from '../../../../../../assets/finance/quiz/smile.png';
import AgainIcon from '../../../../../../assets/education/quiz/again_icon.png';
import ImgPass from '../../../../../../assets/education/quiz/pass_person.png';
import PassDownload from '../../../../../../assets/education/quiz/pass_download.png';
import Certificate from '../../components/Certificate';
import ScoreRating from './ScoreRating';
import { PDFDownloadLink } from '@react-pdf/renderer';

import './index.less';
import './index.en.less';
import QuizReview from '../../components/QuizReview';
import { useGA4React } from 'ga-4-react';
import { LoadingOutlined } from '@ant-design/icons';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import {
  finishTrainingApi,
  generateVerificationCode,
  sendEmail,
  pathToName,
  formatDate,
} from '../../../../../../api/quiz';

interface IQuizTopicProps {
  settings: any;
}

const QuizTopic: React.FunctionComponent<IQuizTopicProps> = ({ settings }) => {
  const param = useParams();
  const navigate = useNavigate();
  const p_course = param.course || '';
  const p_topic = 'quiz';
  const { updateParagraphState } = useStore();
  const {
    getQuizState,
    setQuizAnswer,
    reQuiz,
    getCourseState,
    setCourseState,
    language,
  } = useStore();
  const PDFDownloadLinkRef = React.useRef<HTMLButtonElement>(null);
  let quizResult = getQuizState(p_course);
  const [state, setState] = React.useState<{
    inQuiz: boolean;
    containerWidth: number;
    current: number;
    diableScroll: boolean;
    loadingCert: boolean;
    name: string;
    downloadName: string;
    date: string;
    reviewlist: IQuizResult[];
    isNameEditable: boolean;
    code:string;
  }>({
    inQuiz: false,
    containerWidth: 0,
    current: 1,
    diableScroll: false,
    loadingCert: false,
    name: '',
    downloadName: '',
    date: '',
    reviewlist: [],
    isNameEditable: true,
    code:generateVerificationCode()
  });
  const [trainingId, setTrainingId] = React.useState('');
  const onResize = (w: any) => {
    setState({
      ...state,
      inQuiz: false,
      containerWidth: w,
    });
  };
  const next = () => {
    setState({
      ...state,
      current: state.current + 1,
      diableScroll: state.current + 1 > quizResult.results?.length,
      // date: quizResult.datetime?.toLocaleDateString() || '',
      date: formatDate(),
    });
    document?.querySelector('.final-quiz-container')?.scrollTo({
      top: 0,
      left: 0,
    });
  };
  const prev = () => {
    setState({
      ...state,
      current: state.current - 1,
    });
    document?.querySelector('.final-quiz-container')?.scrollTo({
      top: 0,
      left: 0,
    });
  };
  const onStart  = async () => {
    updateParagraphState(p_course, p_topic, '1', 'completed', []);
    setTimeout(() => {
      document
        .querySelectorAll('[data-paragraph]')[1]
        ?.scrollIntoView({ behavior: 'smooth' });
    }, 20);
  };
  const topic2 = settings?.paragraphs?.[1];
  const answer = settings?.answer;
  const finishTraining = async () => {
    let retryAttempts = 0;
    let success = false;

    while (!success && retryAttempts < 2) {
      setState({
        ...state,
        code:generateVerificationCode()
      })
      try {
        await finishTrainingApi({ id: trainingId});
        success = true;
      } catch (error) {
        console.log('Finish training failed, retrying...');
        retryAttempts++;
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
    }

    if (!success) {
      console.log('Finish training failed after multiple retries');
    }
  };
  React.useEffect(() => {
    setTrainingId('14')
    if (state.current > quizResult.results?.length && quizResult.isPassed) {
      updateParagraphState(p_course, p_topic, '2', 'completed', []);
      setTimeout(() => {
        setState({
          ...state,
          loadingCert: true,
          reviewlist: quizResult?.results
            .map((itm, idx) => ({
              ...itm,
              quizIndex: idx + 1,
            }))
            .filter((itm) => !itm.answer?.isCorrect),
        });
        const courseState = getCourseState(p_course);
        setCourseState(p_course, {
          ...courseState,
          progress: courseState.progress + 20,
          step: courseState.step + 1,
        });
      }, 500);
    }
    if(state.current == quizResult.results?.length && quizResult.isPassed){
      finishTraining();
    }
  }, [state.current, quizResult.isPassed]);
  const restest = () => {
    quizResult = reQuiz(p_course);
    setState({
      ...state,
      current: 1,
      diableScroll: true,
    });
    setTimeout(() => {
      setState({
        ...state,
        current: 1,
        diableScroll: false,
      });
    }, 500);
  };
  const ga = useGA4React();
  const addGaEvent = (name: string) => {
    if (ga) {
      ga.gtag('event', 'download', { name });
    }
  };

  const [downLoading, setDownloading] = React.useState(false);
  const { name, isNameEditable } = state;
  const downloadImage = async (div: any, filename: string) => {
    try {
      const canvas = await html2canvas(div,{ scale: 5});
      canvas.toBlob(function (blob: any) {
        saveAs(blob, filename);
        if(process.env.REACT_APP_DOMAIN==='cpttm'){
          setsSendEmail(blob,filename);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const setsSendEmail = (blob: BlobPart, filename: string) =>{
    const file = new File([blob], filename, {
      type: 'image/png'
    });
    const formData = new FormData();
    const type = pathToName(p_course)||''
    formData.append('file', file); // file是用户选择的文件
    formData.append('name', state.name);
    formData.append('code', state.code);
    formData.append('type',type)
    console.log(formData, state.name)
    sendEmail(formData)
  }
  const handleSaveName = () => {
    if(name.length === 0){
      return message.warning(topic2?.noValueMsg);
    }
    Modal.confirm({
        title: topic2?.confirm?.title,
        content: isNameEditable ? topic2?.confirm?.content : '',
        okText:topic2?.confirm?.okText,
        cancelText:topic2?.confirm?.cancelText,
        onOk: () => {
          setDownloading(true);
          downloadImage(
            document.getElementsByClassName('cert-container')[0],
            `HKirc-Cybersec-Training-Certification-${p_course}.png`
          ).then(() => {
            setDownloading(false);
          });
          setState({ ...state, isNameEditable: false });
        },
      }
    );
  };
  return (
    <TopicContainer className="quiz">
      <TopicItem className="course-landing intro" id="1">
        <div className="course-landing-content ">
          <div className="quiz-text course-landing-text">
            <div className="title">{settings?.message}</div>
            <div className="subtitle">{settings?.subtitle}</div>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: settings?.description }}
            />
            <div className="quiz-btn" onClick={onStart}>
              <img src={DownwardIcon} alt="" />
              {settings?.startBtn}
            </div>
          </div>
        </div>
      </TopicItem>
      <TopicItem
        className={`answer ${
          quizResult.isPassed && state.current > 15 ? 'is-pass' : ''
        }`}
        id="2"
      >
        <div key={quizResult.quizId} className="progress">
          <div
            key={state.current}
            style={{
              width: `${
                (state.current > quizResult.results?.length
                  ? 1
                  : state.current / quizResult.results?.length) * 100
              }%`,
            }}
            className="progress-line"
          />
        </div>
        <div
          className={`answer-list ${
            quizResult.isPassed && state.current > 15 ? 'answer-list-pass' : ''
          }`}
        >
          {state?.current <= quizResult.results?.length ? (
            <ReactResizeDetector onResize={onResize}>
              <div className="final-quiz-container">
                <div
                  className="final-quiz-body"
                  style={{
                    width:
                      state.containerWidth * (quizResult.results?.length + 1),
                    left: -(state.current - 1) * state.containerWidth,
                    transition: state.diableScroll
                      ? 'all 0s linear 0s'
                      : 'all 500ms linear 0s',
                  }}
                >
                  {quizResult.results?.map((quiz: any, index: any) => (
                    <div
                      key={quizResult.quizId + index}
                      style={{
                        width:
                          state.containerWidth === 0
                            ? '100%'
                            : `${state.containerWidth}px`,
                      }}
                    >
                      <FinalQuiz
                        quizIndex={index + 1}
                        quizCount={quizResult.results?.length}
                        answer={answer}
                        // description={quiz.description}
                        question={quiz.question}
                        options={quiz.options}
                        onNext={next}
                        onPrev={prev}
                        onSubmit={(selected) => {
                          setQuizAnswer(
                            p_course,
                            quizResult.quizId,
                            quiz.id,
                            selected as IQuizOption
                          );
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </ReactResizeDetector>
          ) : (
            <div className="quiz-result">
              {quizResult.isPassed ? (
                <>
                  <div className="quiz-result-pass">
                    <div className="pass-box">
                      <div className="right">
                        <div className="quiz-result-title">
                          <h3>
                            <img alt="" src={Smile} />
                            {topic2?.pass?.text}
                          </h3>
                          <div className="tips">
                            <a
                              href="https://forms.office.com/r/cmhxnU3zQy"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span>{topic2?.pass?.l1}</span>
                            </a>
                            <span>{topic2?.pass?.l2}</span>
                            <p>{topic2?.pass?.l3}</p>
                          </div>
                        </div>
                        <div className="cert-download-input">
                          <Input
                            prefix={topic2?.pass?.prefix}
                            className="cert-name-input"
                            placeholder={topic2?.pass?.placeholder}
                            onChange={(e) => {
                              setState({
                                ...state,
                                name: (e.target as HTMLInputElement).value,
                              });
                            }}
                            disabled={!isNameEditable}
                          />
                          <Button
                            className="cert-download-button"
                            type="link"
                            onClick={handleSaveName}
                          >
                            {downLoading ? (
                              <Spin
                                indicator={
                                  <LoadingOutlined
                                    style={{ fontSize: 22, color: 'black' }}
                                    spin
                                  />
                                }
                              />
                            ) : (
                              <span>{topic2?.pass?.download}</span>
                            )}
                            <img
                              className="button-download"
                              src={PassDownload}
                              alt=""
                            />
                          </Button>
                          <PDFDownloadLink
                            key={state.downloadName}
                            style={{ display: 'none' }}
                            document={
                              <Certificate
                                key={state.downloadName}
                                name={state.downloadName}
                                date={state.date}
                                background={
                                  require(`./cert-${process.env.REACT_APP_DOMAIN}.jpg`)
                                    .default
                                }
                              />
                            }
                            fileName="HKirc-Cybersec-Training-Certification-General-Staff.png"
                          >
                            {({ loading }) =>
                              loading ? (
                                ''
                              ) : (
                                <Button
                                  ref={PDFDownloadLinkRef}
                                  disabled={state.downloadName.length === 0}
                                  className="cert-download-button"
                                  type="link"
                                >
                                  <span>{topic2?.pass?.download}</span>
                                </Button>
                              )
                            }
                          </PDFDownloadLink>
                        </div>
                        <div className="cert-area">
                          {state.loadingCert &&
                            quizResult.isPassed &&
                            state.current > quizResult.results.length && (
                              <div className="cert-container">
                                <img
                                  className="cert-bg"
                                  src={
                                    require(`./cert-${process.env.REACT_APP_DOMAIN}.jpg`)
                                      .default
                                  }
                                  alt=""
                                />
                                <div className="cert-username">
                                  {state.name}
                                </div>
                                <div className="cert-adate">{state.date}</div>
                                {process.env.REACT_APP_DOMAIN === 'cpttm' ? (
                                  <div className="cert-code">{state.code}</div>
                                ) : null}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="left">
                        <ScoreRating
                          score={Math.round(quizResult?.score || 0)}
                          word={''}
                        />
                        <img src={ImgPass} alt="" />
                      </div>
                    </div>
                  </div>
                  {state.reviewlist.length <= 0 ? null : (
                    <div className="quiz-review-section">
                      <div className="quiz-result-title">
                        {topic2?.error?.text}
                      </div>
                      <p className="content">
                        {topic2?.error?.l1} {state.reviewlist.length}{' '}
                        {topic2?.error?.l2}
                      </p>
                      {state.reviewlist.map((itm, idx) => (
                        <QuizReview
                          key={idx}
                          language={language}
                          question={itm.question}
                          options={itm.options}
                          quizIndex={itm.quizIndex || 0}
                          answer={itm.answer}
                          topic2={topic2}
                        />
                      ))}
                    </div>
                  )}
                  <div className="nextTopic_box">
                    <Button
                      className="next-topic-button"
                      type="text"
                      onClick={() => navigate(`/`)}
                    >
                      <div className="l1">{topic2?.back}</div>
                    </Button>
                  </div>
                </>
              ) : (
                <div className="quiz-result-not-pass">
                  <div className="right">
                    <div className="quiz-result-title">
                      <img className="upset" src={Upset} alt="" />
                      <span>{topic2?.noPass?.text}</span>
                      <ScoreRating
                        score={Math.round(quizResult?.score || 0)}
                        word={''}
                      />
                    </div>
                    <p className="description">
                      {topic2?.noPass?.l1}
                      <br />
                      {topic2?.noPass?.l2}
                      <br />
                      <span className="description-l3">
                        {topic2?.noPass?.l3}
                      </span>
                    </p>
                    <Button
                      onClick={restest}
                      className="quiz-retry-button"
                      type="link"
                    >
                      <img src={AgainIcon} alt="" />
                      <span>{topic2?.noPass?.test}</span>
                    </Button>
                  </div>
                  <div className="left">
                    <img src={ImgNotPass} alt="" />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </TopicItem>
    </TopicContainer>
  );
};

export default QuizTopic;
